import { render, staticRenderFns } from "./PNLRanking.vue?vue&type=template&id=43baffc6&scoped=true"
import script from "./PNLRanking.vue?vue&type=script&lang=js"
export * from "./PNLRanking.vue?vue&type=script&lang=js"
import style0 from "./PNLRanking.vue?vue&type=style&index=0&id=43baffc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43baffc6",
  null
  
)

export default component.exports